module.exports = "//d274d294w9cx2v.cloudfront.net/273f00e7bf559493e8664c91146cca61ccee9cb2/images/photo-single.png";